export default "__VITE_ASSET__mcLRI21G__"